import { useTranslation } from "react-i18next";

import BaseSkeleton from "@/components_v2/Skeleton/BaseSkeleton";
import BaseSkeletonGroup from "@/components_v2/Skeleton/BaseSkeletonGroup";
import { SKELETON_VARIANTS } from "@/components_v2/Skeleton/constants";

import "@/domains/certifications/components/styles.css";
import "./styles.css";

const WEEK_ROWS = 5;
const ABOUT_CARDS = 3;

const OverviewSkeleton = () => {
  const { t } = useTranslation();

  return (
    <BaseSkeletonGroup
      label={t("labels.loading")}
      className="flex flex-col gap-700"
    >
      <div className="flex flex-col gap-200">
        <BaseSkeleton width="14rem" />

        <BaseSkeleton width="32rem" height="var(--spacing-600)" />

        <BaseSkeleton width="24rem" />
      </div>

      <section className="certification-card path-progress-card flex flex-col gap-300">
        <BaseSkeleton width="12rem" height="var(--spacing-400)" />

        <BaseSkeleton height="var(--spacing-200)" />

        <BaseSkeleton variant={SKELETON_VARIANTS.TEXT} lines={2} />
      </section>

      <section className="flex flex-col gap-400">
        <BaseSkeleton width="12rem" height="var(--spacing-500)" />

        <ul className="certification-card week-list-group">
          {Array.from({ length: WEEK_ROWS }, (_, index) => (
            <li key={index} className="week-row flex items-center gap-300">
              <BaseSkeleton width="4rem" />

              <BaseSkeleton width="40%" />
            </li>
          ))}
        </ul>
      </section>

      <div className="certification-card-row flex flex-wrap gap-300">
        {Array.from({ length: ABOUT_CARDS }, (_, index) => (
          <section
            key={index}
            className="certification-card path-progress-card flex flex-col gap-300"
          >
            <BaseSkeleton width="60%" height="var(--spacing-400)" />

            <BaseSkeleton variant={SKELETON_VARIANTS.TEXT} lines={3} />
          </section>
        ))}
      </div>
    </BaseSkeletonGroup>
  );
};

export default OverviewSkeleton;
